var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showDefaultResults)?_vm._t("default"):_vm._e(),_vm._v(" "),_vm._l((_vm.results),function(result){return _c('search-result',{key:result.fuzzy_id,attrs:{"result":result}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }